import { render, staticRenderFns } from "./ModalRecommend.vue?vue&type=template&id=6b7a6dcc&scoped=true&"
import script from "./ModalRecommend.vue?vue&type=script&lang=js&"
export * from "./ModalRecommend.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecommend.vue?vue&type=style&index=0&id=6b7a6dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a6dcc",
  null
  
)

export default component.exports